( function ($) {

	$( document ).ready( function() {
		/** subpages banner swiper slider **/
		var swiper = new Swiper('.__page_slider_banner', {
		    loop: true,
		    loopedSlides: 3,
		    spaceBetween: 0,
			speed: 1500,
			autoplay: {
				delay: 7000,
				disableOnInteraction: false,
			},
		    navigation: {
		        nextEl: '.swiper-btn-next',
		        prevEl: '.swiper-btn-prev',
      		},
			// pagination: {
			// 	el: '.swiper-pagination',
			// 	clickable: true,
			// },
		});


		/** homepage banner groups logos slider **/
		$('.__banner_groups_slider').slick({
			infinite: true,
			dots: false,
			autoplay: true,
			autoplaySpeed: 0,
			speed: 5000,
			pauseOnHover: true,
			pauseOnFocus: false,
			draggable: false,
			cssEase: 'linear',
			slidesToShow: 4,
			slidesToScroll: 1,
			arrows: false,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
					}
				},
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
					}
				},
				{
					breakpoint: 640,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					}
				},    
			]
		});

		
		/** header main menu superfish **/
	    $('ul#menu-main-menu').superfish({
	    	delay			: 600,
	    	animation		: {opacity:'show', height:'show'},
	    	animationOut	: {opacity:'hide'},
	    	speed			: 'fast'
	    });


		/** header custom search icon click **/
	    $('.header-search span.__search_btn').click(function(event) {
	        event.preventDefault();
	        $('#sb-search').stop().animate({width: 'toggle'});
	    });


		/** subpages swiper slider gallery **/
		// var gallerySlider = new Swiper('.__slider_gallery', {
		// 	slidesPerView: 1,
		//     spaceBetween: 13,
		//     loop: true,
		//     loopedSlides: 3,
		//     speed: 500,
		//     slideToClickedSlide: false,
		//     navigation: {
		//         nextEl: '.swiper-btn-next',
		//         prevEl: '.swiper-btn-prev',
  //     		},
		// 	pagination: {
		// 		el: '.swiper-pagination',
		// 		clickable: true,
		// 	},
		// 	breakpoints: {
		// 			// when window width is >= 512px
		// 			512: {
		// 			slidesPerView: 2,
		// 			spaceBetween: 13
		// 		},
		// 			// when window width is >= 768px
		// 			769: {
		// 			slidesPerView: 3,
		// 			spaceBetween: 13
		// 		},
		// 			// when window width is >= 1024px
		// 			1024: {
		// 			slidesPerView: 3,
		// 			spaceBetween: 13
		// 		},
		// 	}
		// });


		/** autoheight flexible content layout */
		// $( ".flexible-content-section .flex-content-wrapper .flex-content-editor" ).autoHeight({
		// 	'onResize': true,
		// });
		
		$( ".flexible-content-with-border-section .flex-content-wrapper .flex-content-editor" ).autoHeight({
			'onResize': true,
		});


		/** flex content section sub menu click **/
	    $('.flexible-content-section .flex-sub-menu ul li a').click(function() {
	    	$('html, body').animate({
	    		scrollTop: $( $(this).attr('href') ).offset().top
	    	}, 700);
	    	return false;
	    });
	} );
	
	
	$( window ).resize( function() {
	    
	} );
	
	
	$( window ).load( function() {
	    
	} );
	
	
	$( document ).scroll( function() {

	} );

} ( jQuery ) );



/** moby mobile responsive menu **/
var $ = jQuery;

var mobyMenu = new Moby( {
	menu              : $( '#mobile-menu' ), // The menu that will be cloned
	mobyTrigger       : $( '#open-mobile-menu' ), // Button that will trigger the Moby menu to open
	menuClass		  : 'left-side',
	subMenuOpenIcon   : '<i class="fa fa-caret-down"></i>',
	subMenuCloseIcon  : '<i class="fa fa-caret-up"></i>',
	template          : '<div class="moby-close"><span class="moby-close-icon"></span></div><div class="moby-wrap"><div class="moby-menu"></div></div>'
} );